import  {USER_ACTIONS } from '../../constants';

const initialState = {
	type: '',
	showAlert: false
};
const setFlagShowAlert = (state=initialState,action) => {
		switch (action.type) {
		case USER_ACTIONS.SHOW_PSW_RESET:
			return { 
                ...state,
                showAlert: action.action
             };
		default:
			return state;
	}
};
export const setShowPswResetAlert = (action) => ( {type: USER_ACTIONS.SHOW_PSW_RESET,action});

export default setFlagShowAlert;


// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_psw_reset.js